import ArtistBanner from './ArtistBanner';
import ArtistHeader from './ArtistHeader';

export default function ArtistHero() {
  return (
    <div className="relative h-[40vh]">
      <ArtistHeader />
    </div>
  );
} 